
import { Options, Vue } from 'vue-class-component';
import AuthShroud from "@/components/helpers/AuthShroud.vue";
import Region from '@/components/Region.vue';
import UrlService from "@/services/UrlService";

@Options({
    components: {
        AuthShroud,
        Region,
    },
})
export default class App extends Vue {
    regionId: number|null = null

    created() {
        let regionId;

        try {
            regionId = UrlService.getUrlParameter('id');
            regionId = parseInt(String(regionId));
        }
        catch( e ) {
            console.error(e);
            return;
        }

        this.regionId = regionId;
    }
}
